module.exports = __webpack_public_path__ + "static/img/andrew_lee.544183e5.png";